function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "backward"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.848 16.438c-.56-1.262-3.87-7.888-11.848-8.406v-1.032c0-.369-.203-.708-.528-.882-.325-.175-.72-.154-1.026.05l-6 4c-.263.175-.427.464-.444.778-.017.315.116.62.358.822l6 5c.297.248.713.301 1.064.137s.576-.517.576-.905v-1.092c.213-.012.462-.02.744-.02 1.932 0 5.763.384 9.711 2.95.167.108.356.162.545.162h.01c.579.044 1.01-.443 1.01-1 0-.208-.063-.401-.172-.562zm-11.104-3.549c-1.166 0-1.882.12-1.912.126-.438.074-.768.427-.823.857l-3.339-2.783 3.33-2.221v.132c0 .553.448 1 1 1 4.737 0 7.67 2.393 9.317 4.451-3.151-1.323-5.958-1.562-7.573-1.562z"
}));

var Svg013Backward = function Svg013Backward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg013Backward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/013-backward.bd326174.svg";
export { ForwardRef as ReactComponent };